import '../scss/collection.scss';

import "../components/collection-facets";

import { collectionMoreInfo } from "../components/collection";

//Collection button
collectionMoreInfo('#collection__button');
